// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var initialBodyImg = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.width(Css.px(150)),
            /* :: */[
              Css.height(Css.px(150)),
              /* :: */[
                Css.background(Css.white),
                /* :: */[
                  Css.borderRadius(/* `percent */[
                        -119887163,
                        50.0
                      ]),
                  /* :: */[
                    Css.margin4(Css.px(5), Css.px(0), Css.px(5), Css.px(0)),
                    /* :: */[
                      Css.padding2(Css.px(0), Css.px(0)),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var countNumberH4 = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var countNumber = Css.style(/* :: */[
      Css.fontSize(Css.px(40)),
      /* :: */[
        Css.margin2(Css.px(0), Css.px(8)),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* initialBodyImg */initialBodyImg,
  /* countNumberH4 */countNumberH4,
  /* countNumber */countNumber
];

var component = ReasonReact.reducerComponent("Counter");

function make(next, countdownTime, title, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      return React.createElement("div", {
                  className: initialBodyImg
                }, React.createElement("h4", {
                      className: countNumberH4
                    }, title), React.createElement("h1", {
                      className: countNumber
                    }, String(param[/* state */2][/* count */0])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[/* count */countdownTime];
    });
  newrecord[/* reducer */12] = (function (_, state) {
      var match = state[/* count */0];
      if (match !== 0) {
        return /* Update */Block.__(0, [/* record */[/* count */state[/* count */0] - 1 | 0]]);
      } else {
        return /* SideEffects */Block.__(2, [(function () {
                      return Curry._1(next, /* () */0);
                    })]);
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return setInterval((function () {
                                  return Curry._1(self[/* send */4], /* Tick */0);
                                }), 1000);
                  }),
                (function (prim) {
                    clearInterval(prim);
                    return /* () */0;
                  })
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.Styles = Styles;
exports.component = component;
exports.make = make;
/* initialBodyImg Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/counter2.re
// module id = 123
// module chunks = 0